export default __webpack_public_path__ + "static/media/CSS-3.4664b0b9.svg";